module.exports = __webpack_public_path__ + "static/img/virtualReality4.c4a997c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/virtualReality4.png
// module id = 5cBA
// module chunks = 13